import { useCallback } from 'react';
import { PointGeometry } from 'app/agriculture/queries/types/geometry/PointGeometry';
import { ZoomButtons } from 'app/agriculture/components/Tools/components/ZoomButtons/ZoomButtons';
import { Heading } from 'app/agriculture/components/Heading/Heading';
import { MapMarkerIcon } from 'app/agriculture/icons';
import { FarmLocationSearchInput } from 'app/agriculture/routes/BackOffice/FarmCreate/components/FarmLocationSearchInput';
import './FarmLocationInput.scss';
import { useViewerContext } from 'app/agriculture/contexts/ViewerContext/useViewerContext';

export const DEFAULT_ZOOM_HEIGHT = 10000;

export function FarmLocationInput() {
    const { viewer, setViewerRef } = useViewerContext();

    const flyTo = useCallback(
        ({ coordinates: [lon, lat] }: PointGeometry) => {
            if (viewer == null) return;

            viewer.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees(lon, lat, DEFAULT_ZOOM_HEIGHT),
            });
        },
        [viewer],
    );

    return (
        <div className="FarmLocationInput">
            <Heading>Farm Position</Heading>
            <div className="FarmLocationInput__viewer" ref={setViewerRef}>
                <FarmLocationSearchInput
                    className="FarmLocationInput__search"
                    onChange={(geometry) => {
                        flyTo(geometry);
                    }}
                />
                <MapMarkerIcon className="FarmLocationInput__icon" />
                <ZoomButtons className="FarmLocationInput__zoom" viewer={viewer} />
            </div>
        </div>
    );
}
